<ng-template #defaultFooter>
  <div class="d-flex">
    <div class="flex-fill d-none d-md-inline">
      <div class="d-flex">
        <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
        <div class="flex">
          <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
            class="form-control form-select custom-select" aria-label=""
            (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
            <option [ngValue]="250">250</option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
      <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!" [(page)]="tableFunctions.page"
        [pageSize]="tableFunctions.pageSize" [maxSize]="tableFunctions.page == 4 ? 4 : 3" [boundaryLinks]="true"
        [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="flex-fill justify-content-end d-none d-md-inline">
      <div class="d-flex float-end">
        <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
        <div class="flex">
          <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
            aria-label="">
            <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1
              }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<main id="energy-overview">
  <div class="card">
    <nav>
      <div id="nav-tab" role="tablist">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
          <li [ngbNavItem]="'energy-monitor'" domId="tab_energy-monitor" *ngIf="this.hasBlackbox">
            <a ngbNavLink routerLink="energy-monitor" i18n="@@CustomerEnergyLink">
              <app-svg source="icons/feather/pie-chart" height="18"></app-svg>
              Energiemonitor
            </a>
          </li>

          <li [ngbNavItem]="'bidi-charging'" domId="tab_bidi-charging" *ngIf="this.hasBidi">
            <a ngbNavLink routerLink="bidi-charging" i18n="@@CustomerBidiLink">
              <app-svg source="icons/feather/sliders" height="18"></app-svg>Bidi-Laden</a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="card">
      <div class="card-body">
        <div class="tab-content mt-2" id="nav-tabContent">
          <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
        </div>
      </div>
    </div>
  </div>
</main>

